export default __webpack_public_path__ + "static/rene_laan-4cfa9280bd83a855ed9b59c92734e058.jpg";